import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const estados = `${baseUrl}/ubigeo/estados`;

export const allEstadosService = async (params) => {
  try {
    const res = await axios.get(estados, {
      headers: token({}),
      params,
    });
    return res;
  } catch (e) {
    console.log(e);
  }
};
